<template>
  <div>
    <iModal title="新增banner" v-model="showModal" class-name="common-ad-add" width="600px" :mask-closable="false"
      @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100"
            @submit.native.prevent>
            <FormItem label="banner：">
              <div class="my-upload">
                <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index">
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height: 100px;" />
                    <div class="my-upload-list-cover">
                      <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                      <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                      <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList"
                  :on-success="handleSuccess" :format="['jpg', 'jpeg', 'png']" :max-size="2048" :headers="formHeaders"
                  :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload" multiple type="drag" :action="uploadUrl"
                  style="display: inline-block;" v-show="uploadList && uploadList.length < 1">
                  <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                    <div style="font-size:25px">
                      +
                      <p style="font-size:14px">上传图片</p>
                    </div>
                  </div>
                </Upload>
                <iModal title="图片查看" cancel-text v-model="visible">
                  <div style="text-align: center;">
                    <img :src="imgName" v-if="visible" style="max-width: 100%" />
                  </div>
                </iModal>
              </div>
              <p class="upload-p" style="display:block;font-size:12px;">(图片要求：2M以下的jpg或png，建议尺寸为1920*400px)</p>
            </FormItem>
            <!-- <FormItem label="链接地址：">
              <Input v-model="formInline.link" />
            </FormItem> -->
            <FormItem label="显示顺序：">
              <InputNumber :max="9999" :min="0" v-model="formInline.showIndex"></InputNumber>
              <p style="font-size:12px;">（数字越小在您的banner显示中显示越靠前）</p>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "common-banner-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      loading: false,
      showModal: false,
      formInline: {
        // link: "",
        showIndex: 0,
      },
      ruleInline: {
        // title: [{ required: true, message: '请选择标题', trigger: 'change' }],
      },
      uploadList: [],
      defaultList: [],
      imgName: "",
      visible: false,
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  }, 
  methods: {
    ...mapActions({
      addBanner: "liveModule/addBanner",
    }),
    // 查看上传图片
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove (file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    // 上传成功
    handleSuccess (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    // 文件格式错误
    handleFormatError (file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize (file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload () {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    async handleSubmit (name) {
      let form = this.formInline; 
      if (this.uploadList.length == 0) {
        this.$Message.warning("请上传banner封面");
        return;
      }
      let imgList = this.transfromImgList(this.uploadList); 
      let req = { 
        type: "reg-form",
        url: imgList[0] || "", 
        showIndex: form.showIndex, 
      };
      this.loading = true;
      let bool = await this.addBanner(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      } else {
        this.cancel();
        this.$emit("finish");
        this.loading = false;
        this.$Message.success("添加成功！");
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    transfromImgList (arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    cancel () {
      this.formInline.link = "";
      this.formInline.showIndex = 0;
      this.uploadList = [];
      this.$refs.upload.fileList = [];
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
<style lang="scss">
.common-ad-add {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {

  // IE10+ CSS styles go here
  .common-ad-add {
    display: block;

    .ivu-modal {
      top: 150px;
    }
  }
}
</style>
